
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/help",
      function () {
        return require("private-next-pages/agents/help/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/help"])
      });
    }
  